<template>
    <div id="Country">
        <mu-bottom-sheet :open.sync="openBottomCountry">
            <mu-flex direction="column" class="select_container">
                <mu-flex class="header" justify-content="between" align-items="center">
                    <p>{{title}}</p>
                    <mu-button flat color="primary" @click="selected" v-if="selectType == 1">{{$t("common.ok2")}}</mu-button>
                </mu-flex>
                <mu-flex class="select_box" align-items="center" wrap="wrap">
                    <mu-flex class="select_item" :class="item.isSelected? 'selected':''"
                        v-for="(item, index) in selectArray" :key="index" @click="selectItem(index)">
                        {{item[displayProp]}}
                    </mu-flex>
                </mu-flex>
            </mu-flex>
        </mu-bottom-sheet>
    </div>
</template>
<script>
export default {
    name: "BottomCountrySelect",
    data() {
        return {
            openBottomCountry:false,
            selectVal: [],
        }
    },
    props: {
        title: String,
        selectArray: Array,
        displayProp: String,
        selectDone: Function,
        selectType: Number      // 1: 单选， 2：多选
    },
    methods: {
        openSelector() {
            this.openBottomCountry = true;
        },
        selected() {
            for (var i = 0; i < this.selectArray.length; i++) {
                if (this.selectArray[i].isSelected) {
                    this.selectVal.push(this.selectArray[i]);
                }
            }
            this.selectDone(this.selectVal);
            this.openBottomCountry = false;
        },
        selectItem(index) {
            if (this.selectType == 1) {
                this.selectDone(this.selectArray[index]);
                this.openBottomCountry = false;
            } else {
                if (this.selectArray[index].isSelected) {
                    this.selectArray[index].isSelected = false;
                } else {
                    this.selectArray[index].isSelected = true;
                }
                
            }
            this.$forceUpdate();
        }
    }
}
</script>
<style scoped>
.select_container {
    min-height:25vh;
    max-height: 105vh;
    width:100%;
}
.select_container .header {
    background:#f1f3f5;
    padding:4px 8px;
    width:100%;
}
.select_container .select_box {
    background-color:#fff;
    padding:8px 24px;
}
.select_container .select_box .select_item {
    margin:8px;
    padding:4px 16px;
    background:#F0F3F8;
    color:#4E5A63;
    border:1px solid rgba(220,223,230,1);
    transition: all 0.3 ease-in-out;
    cursor: pointer;
    font-size:12px;
}
.select_container .select_box .select_item:hover {
    border:1px solid #4880FF;
    color:#4880FF;
    background:rgba(41, 105, 247, 0.23);
    transition: all 0.3 ease-in-out;
}
.select_container .select_box .selected {
    border:1px solid #4880FF;
    color:#4880FF;
    background:rgba(41, 105, 247, 0.3);
}
</style>


// WEBPACK FOOTER //
// src/components/Country.vue